import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Grid,
  Paper,
  Popover,
  Radio,
  Skeleton,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useAppSelector, useAppDispatch } from 'app/config/store';
import { Link } from 'react-router-dom';
import {
  generateGMapsLinkCords,
  transformDate,
  calculateDistance,
  getAccessToken,
  convertDateToYear,
} from 'app/utils/common-utils/common-utils';
import CloseIcon from '@mui/icons-material/Close';
import { participateInActivity, participateInActivityCard } from 'app/shared/reducers/volunteer';
import ActivityContribute from 'app/components/ui/activity-details-section/activity-resource/activity-contribute';
import { isBefore, isEqual, differenceInMinutes, parseISO } from 'date-fns';
import { announceArrival } from 'app/shared/reducers/announce-arrival';
import toast from 'react-hot-toast';
import AllContributionsListModal from 'app/components/common/modals/all-contributions-list-modal/all-contributions-list-modal';
import AuthorisationModal from 'app/components/common/authorization-modal/authorization-modal';
import './activity-chat-sidebar.scss';
import Cookies from 'js-cookie';
import JoiningSuccessModal from 'app/components/common/modals/joining-success-modal';
import { getPhoneNumber, toggleModalLogin } from 'app/shared/reducers/authentication';
import { getAllEvents, getAllEventsById } from 'app/shared/reducers/chat-messages/left-panel';
import { getAllConversationsById } from 'app/shared/reducers/chat-messages/chat-Panel';
import RadioDialog from 'app/components/common/alert-dialog/radio-dialog';
import { fetchActivityDetails, fetchActivityDetailsUnauthorized, fetchRecurringDetails } from 'app/shared/reducers/activity-home';
import RecurringRangeModal from '../activity-recurring-section/recurring-date-range/recurring-range-modal';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';

import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import axios from 'axios';
import GenericModal from 'app/components/common/modals/generic-modal';
import { fetchBanned, fetchBlocked } from 'app/shared/reducers/profile';
import PhoneVerification from '../phone-verification/phone-verification';

const ActivityChatSideBar = ({
  activityResponseParent,
  volunteerButtonClick,
  isSubmitClicked,
  onVolunteerButtonClick,
  onIsSubmitClicked,
}) => {
  const [activityResponse, setactivityResponse] = useState<any>(activityResponseParent);
  const theme = useTheme();
  const isSmallerScreen = useMediaQuery(theme.breakpoints.down(400));
  const dispatch = useAppDispatch();
  const isDarkMode = theme.palette.mode === 'dark';
  const [activityLocation, setactivityLocation] = useState<any>({});
  const [currentLocation, setcurrentLocation] = useState<any>({});
  const [isReached, setisReached] = useState<boolean>(false);
  const [manualClick, setManualClick] = useState<boolean>(false);
  const [isContributeOpen, setIsContributeOpen] = useState(false);
  const [viewContributions, setviewContributions] = useState(false);
  const success = useAppSelector(state => state.chatPanelReducer.success);
  const [calDialogOpen, setCalDialogOpen] = useState(false);
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [childrens, setChildrens] = React.useState<any>([]);
  const [isVolunteerModalOpen, setIsVolunteerModalOpen] = useState(false);

  const [authModalOpen, setAuthModalOpen] = React.useState(false);
  const [currentComponent, setCurrentComponent] = React.useState(' ');
  const [openModal, setOpenModal] = useState(false);
  // const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
  const myCookieValue = Cookies.get('jhi-authenticationToken');
  const authenticationToken = myCookieValue;
  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
  const consentPending = useAppSelector(state => state.authentication.consentPending);
  const isAuthenticatedAndConsented = isAuthenticated && !consentPending;
  const userOwnedOrganizations = useAppSelector(state => state.organizationReducer.userOwnedOrganization);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [isEmpty, setIsEmpty] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedOrgId, setSelectedOrgId] = useState(null);

  let token;

  const [showOrgDialog, setShowOrgDialog] = useState(false);
  const handleOrgsDialog = value => {
    setShowOrgDialog(value);
  };

  const [currentActivityId, setCurrentActivityId] = useState(null);

  const getCurrentActivity = id => {
    setCurrentActivityId(id);
  };
  const clearCurrentActivity = () => {
    setCurrentActivityId(null);
  };

  useEffect(() => {
    console.log('Inside activityResponseParent', activityResponseParent);
    if (activityResponseParent?.recurringId === null) setactivityResponse(activityResponseParent);
  }, [activityResponseParent]);

  const handleOptionChange = event => {
    const selectedValue = event.target.value;

    if (parseInt(selectedValue, 10) === 1) {
      setSelectedOrgId(1);
      setSelectedOption('My Self');
    } else {
      const selectedOrganization = userOwnedOrganizations.find(organization => organization.id === parseInt(selectedValue, 10));

      if (selectedOrganization) {
        setSelectedOption(selectedOrganization.label);
        setSelectedOrgId(selectedOrganization.id);
      }
    }
  };

  const handleInstructionsModal = value => {
    setIsVolunteerModalOpen(value);
  };

  const handleCancel = () => {
    setShowOrgDialog(false);
    setSelectedOrgId(null);
    setSelectedOption('');
  };

  const changeOrgId = value => {
    setSelectedOrgId(value);
  };

  const [phoneVerificationStatus, setPhoneVerificationStatus] = useState(true);
  const [phoneVerificationModal, setPhoneVerificationModal] = useState<boolean>(false);
  const [otpVerificationCompleted, setOtpVerificationCompleted] = useState(false);
  const [phoneInputCompleted, setPhoneInputCompleted] = useState(false);
  useEffect(() => {
    if (localStorage.getItem('getPhone') && localStorage.getItem('getPhone') !== undefined) {
      const phoneDataString = localStorage.getItem('getPhone');
      if (phoneDataString) {
        try {
          const phoneData = JSON.parse(phoneDataString);
          if (typeof phoneData.verified === 'boolean') {
            setPhoneVerificationStatus(phoneData.verified);
          } else {
            console.error('Verified status is missing or invalid in localStorage data');
          }
        } catch (error) {
          console.error('Failed to parse phone data from localStorage:', error);
        }
      } else {
        console.log('No phone data found in localStorage');
      }
    }
  }, [localStorage.getItem('getPhone')]);

  const handlePhoneVerificationClose = () => {
    setPhoneVerificationModal(false);
    if (otpVerificationCompleted) {
      fetchPhoneNumber();
    } else {
      setPhoneInputCompleted(false);
    }
  };

  const fetchPhoneNumber = async () => {
    try {
      const response = await dispatch(getPhoneNumber());
      if (response.meta.requestStatus == 'fulfilled') {
        localStorage.setItem('getPhone', JSON.stringify(response.payload));
        setPhoneVerificationStatus(response.payload?.verified);
      } else {
        // toast.error('Unable to fetch verification Status', { id: 'phone-verification-status-error' });
      }
    } catch (error) { }
  };

  const handleVolunteerAs = async id => {
    if (isAuthenticated) {
      const res = await dispatch(fetchBanned({ userId: JSON.parse(localStorage.getItem('MyDetailsAccount'))?.id }));
      if (fetchBanned.rejected.match(res)) {
        if (!res.payload) {
          toast.error('Check your internet connection.', { id: 'offline' });
        } else {
          toast.error('Oops! Something went wrong.', { id: 'server-error' });
        }
        return;
      }
      if (res?.payload) {
        toast.error(<>Action Restricted: You cannot perform this action as you are banned by the admin.</>);
        return;
      }
      const res1 = await dispatch(fetchBlocked({ userId: activityResponse?.createdBy }));
      if (fetchBlocked.rejected.match(res1)) {
        if (!res1.payload) {
          toast.error('Check your internet connection.', { id: 'offline' });
        } else {
          toast.error('Oops! Something went wrong.', { id: 'server-error' });
        }
        return;
      }
      if (res1?.payload) {
        toast.error(<>Action Restricted: You cannot volunteer for this activity.</>);
        return;
      }

      if (phoneVerificationStatus) {
        if (userOwnedOrganizations.length > 0) {
          if (selectedOption && currentActivityId === id) {
            openVolunteerModal();
          } else {
            handleOrgsDialog(true);
            getCurrentActivity(id);
          }
        } else {
          handleOrgsDialog(false);
          changeOrgId(1);
          getCurrentActivity(id);
          openVolunteerModal();
        }
      } else {
        setPhoneVerificationModal(true);
      }
    } else {
      setCurrentComponent('login');
      dispatch(toggleModalLogin());

      setAuthModalOpen(true);
    }
  };

  const authTokenFromStorage = (async () => {
    try {
      const authToken = await getAccessToken();
      if (authToken) {
        return authToken;
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error:', error);
      return null;
    }
  })();
  (async () => {
    token = await authTokenFromStorage;
  })();

  useEffect(() => {
    const allResourcesEmpty = activityResponse?.resources?.filter(item => item.filled > 0);
    allResourcesEmpty?.length === 0 ? setIsEmpty(true) : setIsEmpty(false);
  }, [activityResponse]);

  useEffect(() => {
    const latitude = activityResponse?.latitude;
    const longitude = activityResponse?.longitude;
    const activityLocation = {
      latitude: latitude,
      longitude: longitude,
    };
    setactivityLocation(activityLocation);
  }, [volunteerButtonClick, isSubmitClicked]);

  const handleModalClose = () => {
    setOpenModal(false);
  };

  const handleAuthModalClose = () => {
    setAuthModalOpen(false);
  };

  const openVolunteerModal = () => {
    if (token !== null && token?.length) {
      setIsVolunteerModalOpen(true);
    } else {
      setCurrentComponent('login');
      dispatch(toggleModalLogin());

      setAuthModalOpen(true);
    }
  };

  const errors = err => {
    console.warn(`ERROR(${err.code}): ${err.message}`);
  };

  // check if user's location is within 100 meters of event location
  const isWithin100Meters = (userLocation, eventLocation) => {
    const distance = calculateDistance(userLocation, eventLocation);
    return distance < 100;
  };

  // Check if today is the activity start day
  const isCurrentDateEqualToEventDate = startDate => {
    const currentDate = new Date();
    const eventDate = new Date(startDate);

    currentDate.setHours(0, 0, 0, 0);
    eventDate.setHours(0, 0, 0, 0);

    return isEqual(currentDate, eventDate);
  };

  // check if current time is within 30 minutes of start time of the activity
  const isCurrentTimeWithin30MinutesBeforeActivityStart = activityStartTime => {
    const currentDateTime = new Date();
    const eventDateTime = parseISO(activityStartTime);
    // Check if the current time is before the event time
    if (isBefore(currentDateTime, eventDateTime)) {
      // Calculate the time difference in minutes
      const timeDifferenceMinutes = differenceInMinutes(eventDateTime, currentDateTime);
      // Check if the difference is less than or equal to 30 minutes
      return timeDifferenceMinutes <= 30;
    }
    return false; // Event time has already passed
  };

  const isAnnounceArrivalButtonVisible = (activityDate, activityTime) => {
    if (isCurrentDateEqualToEventDate(activityDate) && isCurrentTimeWithin30MinutesBeforeActivityStart(activityTime)) {
      return true;
    } else {
      return false;
    }
  };

  const handleAnnounceArrival = async () => {
    let currentLocation;
    try {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          async function (position) {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            currentLocation = {
              latitude: latitude,
              longitude: longitude,
            };
            setcurrentLocation(currentLocation);
            // announce arrival
            const response = await dispatch(
              announceArrival({
                activityId: activityResponse?.id,
                latitude: currentLocation.latitude,
                longitude: currentLocation.longitude,
              })
            );
            if (response.meta.requestStatus == 'fulfilled') {
              toast.success(response.payload, { id: 'announce-arrival-success' });
              setisReached(true);
            } else {
              toast.error(response.payload, { id: 'announce-arrival-error' });
            }
          },
          function (error) {
            if (error.code === error.PERMISSION_DENIED) {
              alert('Location access denied. Please enable location services.');
            } else {
              alert('Error getting location: ' + error.message);
            }
          }
        );
      } else {
        alert('Geolocation is not supported in this browser.');
      }
    } catch (error) {
      toast.error('something went wrong!!', { id: 'announce-arrival-something-wrong' });
      console.error('API error:', error);
    }
  };

  const joinAndProceed = async () => {
    setIsButtonClicked(true);
    try {
      let response;
      if (selectedOrgId === null || selectedOrgId === 1) {
        response = await dispatch(participateInActivityCard({ activityIds: [activityResponse?.id], participantType: selectedParticipantOption }));
      } else {
        response = await dispatch(participateInActivityCard({ activityIds: [activityResponse?.id], organizationId: selectedOrgId, participantType: selectedParticipantOption }));
      }
      if (response.meta.requestStatus == 'fulfilled') {
        setIsButtonClicked(false);
        setIsVolunteerModalOpen(false);
        setOpenModal(true);
        setManualClick(true);
        fetchData();

        fetchActivitiesInfo(activityResponseParent?.id);
        // onVolunteerButtonClick(!volunteerButtonClick);
      } else {
        setIsVolunteerModalOpen(false);
      }
    } catch (error) {
      console.error('Error joining the activity:', error);
    }
  };

  const handleResource = () => {
    setIsContributeOpen(true);
  };

  const handleResourceClose = () => {
    setIsContributeOpen(false);
    fetchActivitiesRecurringInfo(activityResponse?.id);
  };

  const handleContributionsViewModal = () => {
    setviewContributions(true);
  };

  const handleContributionsViewModalClose = () => {
    setviewContributions(false);
    fetchActivitiesRecurringInfo(activityResponse?.id);
  };
  const isSmallDevice = useMediaQuery(theme.breakpoints.down('sm'));
  const buttonText = isSmallDevice
    ? (activityResponse?.participantOption === "VOLUNTEER_ONLY" ? 'Volunteer' : 'Attendee')
    : (activityResponse?.participantOption === "VOLUNTEER_ONLY" ? 'I want to volunteer' : 'I want to attend');

  const [selectedParticipantOption, setSelectedParticipantOption] = useState<string | null>(null);
  const [participantAnchorEl, setParticipantAnchorEl] = useState<null | HTMLElement>(null);

  const handleParticipantPopoverOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setParticipantAnchorEl(event.currentTarget);
  };

  const handleParticipantPopoverClose = () => {
    setParticipantAnchorEl(null);
  };

  const isParticipantPopoverOpen = Boolean(participantAnchorEl);

  const toolTipText = !isAuthenticated
    ? null
    : isAuthenticated && !activityResponse?.participant
      ? 'Be a volunteer to access the link'
      : null;
  const activityPostingRules = JSON.parse(localStorage.getItem('postingRules'));

  const VolunteerModal = (
    <Grid>
      {activityResponse && (
        <Grid>
          <Dialog
            open={isVolunteerModalOpen && activityResponse.id === currentActivityId}
            onClose={() => {
              setIsVolunteerModalOpen(false);
              handleCancel();
            }}
            PaperProps={{
              sx: {
                borderRadius: '15px',

                padding: '2%',
              },
            }}
          >
            <Stack direction="row" alignItems={'center'} justifyContent={'flex-end'}>
              <CloseIcon
                onClick={() => {
                  setIsVolunteerModalOpen(false);
                  handleCancel();
                }}
                sx={{ cursor: 'pointer' }}
              />
            </Stack>

            <DialogContent sx={{ height: 'auto', overflowY: 'hidden' }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                {activityPostingRules && activityPostingRules?.length > 0 ? (
                  <Grid>
                    <Typography sx={{ fontSize: '14px/22px', color: isDarkMode ? '#FFCE00' : '#674BFF', marginBottom: '10px' }}>
                      {selectedParticipantOption !== 'ATTENDEE'
                        ? 'Instructions for volunteers'
                        : 'Instructions for attendees'}
                    </Typography>
                    <Paper
                      elevation={3}
                      sx={{
                        backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0.16), rgba(255, 255, 255, 0.16))',
                        height: '150px',
                        width: '100%',
                        overflowX: 'hidden',
                        boxShadow: 'none',
                        overflowY: activityPostingRules && activityPostingRules?.length > 2 ? 'scroll' : 'hidden',
                        scrollbarWidth: 'thin',
                        '&::-webkit-scrollbar': {
                          display: 'block',
                        },
                        '&::-webkit-scrollbar-track': {
                          backgroundColor: 'primary.light',
                        },
                        '&::-webkit-scrollbar-thumb': {
                          backgroundColor: '#AAA',
                          borderRadius: '16px',
                        },
                      }}
                    >
                      {activityPostingRules?.length
                        ? activityPostingRules?.map(item => (
                          <Stack key={item.id} direction="row" spacing={1} alignItems="flex-start" justifyContent={'flex-start'}>
                            <Stack p={0.7}>
                              <Box
                                sx={{
                                  width: '9px',
                                  height: '9px',
                                  borderRadius: '50%',
                                  backgroundColor: '#775FFF',
                                }}
                              />
                            </Stack>

                            <Stack direction="row" sx={{ color: theme.textColor.paragraph, gap: 0.2, px: { xs: 0 } }}>
                              <Typography sx={{ fontSize: theme.infoText.regular.fontSize }}>{item.description}</Typography>
                            </Stack>
                          </Stack>
                        ))
                        : null}
                    </Paper>
                  </Grid>
                ) : null}
              </div>
              <div className="mt-2" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                {activityResponse?.instructions && activityResponse?.instructions?.length > 0 ? (
                  <Grid>
                    <Typography sx={{ fontSize: '14px/22px', color: isDarkMode ? '#FFCE00' : '#674BFF', marginBottom: '10px' }}>
                      Instructions by organizers
                    </Typography>

                    <Paper
                      elevation={3}
                      sx={{
                        backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0.16), rgba(255, 255, 255, 0.16))',
                        p: 2,
                        height: '141px',
                        width: '100%',
                        overflowX: 'hidden',
                        boxShadow: 'none',
                        overflowY: activityResponse?.instructions && activityResponse?.instructions?.length > 2 ? 'scroll' : 'hidden',
                        scrollbarWidth: 'none',
                        '&::-webkit-scrollbar': {
                          display: 'none',
                        },
                        '&::-webkit-scrollbar-track': {
                          backgroundColor: 'primary.light',
                        },
                        '&::-webkit-scrollbar-thumb': {
                          backgroundColor: '#AAA',
                          borderRadius: '16px',
                        },
                      }}
                    >
                      {activityResponse?.instructions?.length
                        ? activityResponse?.instructions?.map(item => (
                          <Stack key={item.id} direction="row" spacing={1} alignItems="flex-start" justifyContent={'flex-start'}>
                            <Stack p={0.7}>
                              <Box
                                sx={{
                                  width: '9px',
                                  height: '9px',
                                  borderRadius: '50%',
                                  backgroundColor: '#775FFF',
                                }}
                              />
                            </Stack>

                            <Stack direction="row" sx={{ color: theme.textColor.paragraph, gap: 0.2, px: { xs: 0 } }}>
                              <Typography sx={{ fontSize: theme.infoText.regular.fontSize }}>{item.instruction}</Typography>
                            </Stack>
                          </Stack>
                        ))
                        : null}
                    </Paper>
                  </Grid>
                ) : null}
              </div>
            </DialogContent>

            <DialogActions
              sx={{
                justifyContent: 'center',
                textAlign: 'center',
              }}
            >
              <Stack
                direction={'column'}
                gap={1}
                sx={{
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Button
                  onClick={() => joinAndProceed()}
                  sx={{
                    background: theme.palette.primary.main,
                    color: '#292D34',
                    borderRadius: '15px',
                    width: '159px',
                    height: '40px',
                    '&:hover': {
                      background: theme.palette.primary.main,
                      color: '#292D34',
                      borderRadius: '15px',
                      width: '159px',
                      height: '40px',
                    },
                  }}
                  disabled={isButtonClicked}
                >
                  Join & proceed
                </Button>

                <Typography sx={{ fontSize: '14px', color: theme.textColor.heading }}>
                  By joining this event you accept the rules/instructions of this event.
                </Typography>
              </Stack>
            </DialogActions>
          </Dialog>
        </Grid>
      )}
    </Grid>
  );

  useEffect(() => {
    if (childrens && activityResponseParent?.recurringId) {
      const now = new Date().getTime();

      const filteredData = childrens.filter(item => !item.parent);
      const sortedData = filteredData.sort((a, b) => {
        const timeA = new Date(a.startDate).getTime();
        const timeB = new Date(b.startDate).getTime();

        const diffA = Math.abs(timeA - now);
        const diffB = Math.abs(timeB - now);

        return diffA - diffB;
      });

      if (sortedData.length > 0) {
        const selectedId = sortedData[0]?.id;
        fetchActivitiesRecurringInfo(selectedId);
      }
    }
  }, [childrens, activityResponseParent?.recurringId]);

  // console.log('checkmine', activityResponse);
  const fetchActivitiesRecurringInfo = async id => {
    let response;
    if (isAuthenticatedAndConsented) {
      response = await dispatch(fetchActivityDetails(id));
    } else {
      response = await dispatch(fetchActivityDetailsUnauthorized(id));
    }
    if (response.meta.requestStatus == 'fulfilled') {
      setactivityResponse(response?.payload);
    } else {
      // toast.error('No activity details found.', { id: 'activity-fetch-error' });
    }
  };
  const handleCalender = () => {
    setManualClick(false);
    setCalDialogOpen(true);
  };
  const [currentSelected, setCurrentSelecetd] = React.useState<number>(0);
  const handleCloseModal = filteredDataId => {
    setCalDialogOpen(false);
    fetchActivitiesRecurringInfo(filteredDataId);
    setCurrentSelecetd(filteredDataId);
  };
  const fetchData = async () => {
    if (activityResponseParent?.recurringId) {
      try {
        const response = await dispatch(fetchRecurringDetails(Number(activityResponseParent?.recurringId)));
        // Access the response data here()
        setChildrens(response?.payload);
      } catch (error) {
        console.error('Recurring failed:', error);
      }
    }
  };
  useEffect(() => {
    if (activityResponseParent?.recurringId) fetchData();
  }, [activityResponseParent?.recurringId]);

  const fetchActivitiesInfo = async id => {
    let response;
    if (isAuthenticatedAndConsented) {
      response = await dispatch(fetchActivityDetails(id));
    } else {
      response = await dispatch(fetchActivityDetailsUnauthorized(id));
    }
    if (response.meta.requestStatus == 'fulfilled') {
      setactivityResponse(response?.payload);
    }
  };

  const [confirmLostPet, setConfirmLostPet] = React.useState<boolean>(false);
  const [lostDone, setLostDone] = useState<any>(false);
  const markAsDone = async (id: string) => {
    try {
      const response = await axios.post<any>(`/api/activities/${id}/complete`);
      if (response) {
        setLostDone(true);
      }
    } catch (error) {
      console.log('Error fetching goal:', error);
    }
  };
  const handleConfirmClick = () => {
    markAsDone(activityResponse?.id);
    setConfirmLostPet(false);
  };

  const modalActionLostButtons = [
    { label: 'Yes', onClick: handleConfirmClick },
    { label: 'No', onClick: () => setConfirmLostPet(false) },
  ];

  return (
    <div>
      <RadioDialog
        selectedOrgId={selectedOrgId}
        open={showOrgDialog}
        handleShow={handleOrgsDialog}
        handleOptionChange={handleOptionChange}
        handleCancel={handleCancel}
        handleInstructionsModal={handleInstructionsModal}
        title={selectedParticipantOption === 'ATTENDEE' ? "Attending as" : "Volunteering as"}
      />

      {!activityResponse && <Skeleton variant="rectangular" width={50} height={300} />}
      {activityResponse && Object.keys(activityResponse).length > 0 && (
        <Grid container padding={0} gap={0}>
          {VolunteerModal}
          <Grid item container>
            <Grid padding={1} sx={{ width: '100%', marginRight: '6px' }}>
              {activityResponseParent?.recurringId != null && (
                <div>
                  <CalendarMonthIcon
                    onClick={handleCalender}
                    sx={{ height: '22px', width: '25px', color: isDarkMode ? '#FFCE00' : '#674BFF', cursor: 'pointer' }}
                  />
                  <span style={{ fontSize: '14px', color: isDarkMode ? '#BFBFBF' : '#676E7B' }}>
                    {convertDateToYear(activityResponse?.startDate)}
                  </span>
                </div>
              )}
              <Typography
                sx={{
                  color: theme.textColor.mainHeading,
                  fontSize: theme.p1.semiBold.fontSize,
                  fontWeight: theme.p1.semiBold.fontWeight,
                }}
              >
                Instructions
              </Typography>
              <Paper
                elevation={3}
                sx={{
                  background: isDarkMode ? '#2C2C38' : '#FFFFFF',
                  borderRadius: '16px',
                  p: 2,
                  paddingLeft: '0px',
                  height: '105px',
                  width: '100%',
                  overflowX: 'hidden',
                  boxShadow: 'none',
                  scrollbarWidth: 'auto',
                  '&::-webkit-scrollbar': {
                    display: 'block',
                    width: '8px',
                  },
                  '&::-webkit-scrollbar-track': {
                    backgroundColor: isDarkMode ? '#2C2C38' : '#f0f0f0',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#AAA',
                    borderRadius: '16px',
                  },
                }}
              >
                {activityResponse?.instructions?.length ? (
                  activityResponse?.instructions?.map(item => (
                    <Stack key={item.id} direction="row" spacing={1} alignItems="flex-start" justifyContent={'flex-start'}>
                      <Stack p={0.7}>
                        <Box
                          sx={{
                            width: '9px',
                            height: '9px',
                            borderRadius: '50%',
                            backgroundColor: '#775FFF',
                          }}
                        />
                      </Stack>
                      <Stack direction="row" sx={{ color: theme.textColor.paragraph, gap: 0.2, px: { xs: 0, lg: 0 } }}>
                        <Typography sx={{ fontSize: theme.infoText.regular.fontSize }}>{item.instruction}</Typography>
                      </Stack>
                    </Stack>
                  ))
                ) : (
                  <Typography sx={{ textAlign: 'left' }}>Organizer has not listed any instructions.</Typography>
                )}
              </Paper>
            </Grid>
          </Grid>
          <hr style={{ width: '100%', textAlign: 'left', marginLeft: '0' }}></hr>

          <Grid sx={{ width: '100%', marginRight: '6px' }}>
            <Grid padding={1}>
              <Typography
                sx={{
                  color: theme.textColor.mainHeading,
                  fontSize: theme.p1.semiBold.fontSize,
                  fontWeight: theme.p1.semiBold.fontWeight,
                }}
              >
                Resources needed
              </Typography>
              {!isEmpty && (
                <Typography
                  sx={{
                    color: theme.palette.secondary.light,
                    fontSize: theme.infoText.regular.fontSize,
                    fontWeight: theme.infoText.regular.fontWeight,
                    paddingBottom: '12px',
                  }}
                >
                  Please add your contributions that you are willing to bring
                </Typography>
              )}
              {!isEmpty && (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Link
                    style={{ paddingBottom: '12px', fontSize: '14px', fontWeight: '600', color: '#674BFF', textDecoration: 'none' }}
                    onClick={() => handleContributionsViewModal()}
                    to={''}
                  >
                    View contributors
                  </Link>
                </div>
              )}

              {activityResponse?.resources?.length === 0 && (
                <Typography sx={{ textAlign: 'left' }}>Organizer has not listed any resources.</Typography>
              )}
              <Paper
                className="hide-scrol "
                elevation={3}
                sx={{
                  background: isDarkMode ? '#2C2C38' : '#FFFFFF',
                  borderRadius: '16px',
                  p: 1,
                  height: '100px',
                  width: '100%',
                  overflowX: 'hidden',
                  overflowY: activityResponse?.resources?.length > 1 ? 'scroll' : 'hidden',
                  boxShadow: 'none',
                  scrollbarWidth: 'auto',
                  '&::-webkit-scrollbar': {
                    display: 'block',
                    width: '8px',
                  },
                  '&::-webkit-scrollbar-track': {
                    backgroundColor: isDarkMode ? '#2C2C38' : '#f0f0f0',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#AAA',
                    borderRadius: '16px',
                  },
                }}
              >
                <ol style={{ paddingLeft: '8px' }}>
                  {activityResponse?.resources?.length
                    ? activityResponse?.resources.map((resource, index) => (
                      <li key={index} className="pb-2">
                        <Typography
                          sx={{
                            color: theme.textColor.mainHeading,
                            fontSize: theme.p1.regular.fontSize,
                            fontWeight: theme.p1.regular.fontWeight,
                          }}
                        >
                          {resource.resources}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: theme.infoText.bold.fontSize,
                            fontWeight: theme.infoText.bold.fontWeight,
                            color: resource.filled >= resource.totalCount ? ' #00B158' : '#FF4B8E',
                          }}
                        >
                          {resource.filled >= resource.totalCount
                            ? `${resource.filled}/${resource.totalCount} Filled `
                            : `${resource.filled}/${resource.totalCount} Filled `}
                        </Typography>
                      </li>
                    ))
                    : null}
                </ol>
              </Paper>
            </Grid>
          </Grid>

          {activityResponse?.resources?.length ? (
            <Grid className="mt-3" item container justifyContent={'center'} alignItems={'center'} gap={2} marginBottom={2}>
              {activityResponse?.participant &&
                (activityResponse?.activityStatus === 'OPEN' || activityResponse?.activityStatus === 'RUNNING') && (
                  <Button
                    variant="outlined"
                    sx={{
                      borderRadius: '15px',
                      fontSize: '14px',
                      fontWeight: '600',
                      color: theme.palette.mode === 'dark' ? '#FFCE00' : '#674BFF',
                      borderColor: isDarkMode ? '#ffce00' : '#674bff',
                    }}
                    onClick={() => handleResource()}
                    disabled={activityResponse?.resources?.length === 0 || activityResponse?.attendee}
                  >
                    {activityResponse?.attendee ? 'Attendees are unable to contribute' : 'Contribute'}
                  </Button>
                )}
            </Grid>
          ) : null}

          {activityResponse?.participantOption !== "BOTH" && !activityResponse?.currentActivityVolunteer &&
            !manualClick &&
            activityResponse.activityStatus === 'OPEN' &&
            !activityResponse.makeThisPrivateActivity && (
              <Grid item container justifyContent={'center'} alignItems={'center'} className="mb-2">
                <Tooltip
                  title={
                    activityResponse?.attendeeFilled
                      ? 'Attendee capacity is full'
                      : activityResponse?.volunteerFilled
                        ? 'Volunteer capacity is full'
                        : ''
                  }

                  arrow
                >
                  <span>
                    <Button
                      variant="contained"
                      style={{ textTransform: 'none' }}
                      sx={{
                        borderRadius: '15px', fontSize: '14px', fontWeight: '600',
                        cursor: activityResponse?.attendeeFilled || activityResponse?.volunteerFilled ? 'not-allowed' : 'pointer',
                      }}
                      onClick={() => {
                        if (activityResponse?.participantOption === "VOLUNTEER_ONLY") {
                          setSelectedParticipantOption("VOLUNTEER");
                        } else if (activityResponse?.participantOption === "ATTENDEE_ONLY") {
                          setSelectedParticipantOption("ATTENDEE");
                        }
                        handleVolunteerAs(activityResponse?.id);
                      }}
                      disabled={activityResponse?.attendeeFilled || activityResponse?.volunteerFilled}
                    >
                      {buttonText}
                    </Button>
                  </span>
                </Tooltip>
              </Grid>
            )}

          {activityResponse?.participantOption === "BOTH" && !activityResponse?.currentActivityVolunteer &&
            !manualClick &&
            activityResponse.activityStatus === 'OPEN' &&
            !activityResponse.makeThisPrivateActivity && (
              <Grid item container justifyContent={'center'} alignItems={'center'} className="mb-2">
                <Button
                  variant="contained"
                  style={{ textTransform: 'none' }}
                  sx={{ borderRadius: '15px', fontSize: '14px', fontWeight: '600' }}
                  onClick={handleParticipantPopoverOpen}
                >
                  I want to join
                </Button>
              </Grid>
            )}
          {!activityResponse?.participant &&
            !activityResponse?.invited &&
            activityResponse?.makeThisPrivateActivity &&
            activityResponse.activityStatus == 'OPEN' && (
              <Grid item container justifyContent={'center'} alignItems={'center'} className="mb-2">
                <Button
                  variant="text"
                  style={{ textTransform: 'none' }}
                  sx={{
                    color: isDarkMode ? '#FFCE00' : '#674BFF',
                    fontSize: '14px',
                    borderRadius: '20px',
                    height: '28px',
                    lineHeight: '12px',
                    '&:hover': {
                      backgroundColor: 'none',
                    },
                  }}
                >
                  By invite only
                </Button>
              </Grid>
            )}

          {activityResponse?.participantOption !== "BOTH" && !activityResponse?.currentActivityVolunteer &&
            !manualClick &&
            activityResponse.activityStatus === 'OPEN' &&
            activityResponse.makeThisPrivateActivity &&
            activityResponse.invited && (
              <Grid item container justifyContent={'center'} alignItems={'center'} className="mb-2">
                <Tooltip
                  title={
                    activityResponse?.attendeeFilled
                      ? 'Attendee capacity is full'
                      : activityResponse?.volunteerFilled
                        ? 'Volunteer capacity is full'
                        : ''
                  }

                  arrow
                >
                  <span>
                    <Button
                      variant="contained"
                      style={{ textTransform: 'none' }}
                      sx={{
                        borderRadius: '15px', fontSize: '14px', fontWeight: '600',
                        cursor: activityResponse?.attendeeFilled || activityResponse?.volunteerFilled ? 'not-allowed' : 'pointer',
                      }}
                      onClick={() => {
                        if (activityResponse?.participantOption === "VOLUNTEER_ONLY") {
                          setSelectedParticipantOption("VOLUNTEER");
                        } else if (activityResponse?.participantOption === "ATTENDEE_ONLY") {
                          setSelectedParticipantOption("ATTENDEE");
                        }
                        handleVolunteerAs(activityResponse?.id);
                      }}
                      disabled={activityResponse?.attendeeFilled || activityResponse?.volunteerFilled}
                    >
                      {buttonText}
                    </Button>
                  </span>
                </Tooltip>
              </Grid>
            )}

          {activityResponse?.participantOption === "BOTH" && !activityResponse?.currentActivityVolunteer &&
            !manualClick &&
            activityResponse.activityStatus === 'OPEN' &&
            activityResponse.makeThisPrivateActivity &&
            activityResponse.invited && (
              <Grid item container justifyContent={'center'} alignItems={'center'} className="mb-2">
                <Button
                  variant="contained"
                  style={{ textTransform: 'none' }}
                  sx={{ borderRadius: '15px', fontSize: '14px', fontWeight: '600' }}
                  onClick={handleParticipantPopoverOpen}
                >
                  I want to join
                </Button>
              </Grid>
            )}
          {activityResponse?.activityStatus === 'OPEN' && !activityResponse?.attendee &&
            activityResponse?.currentActivityVolunteer &&
            !activityResponse?.hasPermission && (
              <Grid item container justifyContent={'center'} alignItems={'center'} className="mb-2">
                <Button
                  variant="text"
                  sx={{
                    fontSize: '14px',
                    borderRadius: '20px',
                    height: '28px',
                    lineHeight: '12px',
                    cursor: 'auto',
                    color: isDarkMode ? '#FFCE00' : '#674BFF',
                    '&:hover': {
                      color: 'primary.light',
                    },
                  }}
                >
                  Thanks for joining.
                </Button>
              </Grid>
            )}

          {activityResponse?.activityStatus === 'OPEN' && activityResponse?.attendee &&
            activityResponse?.currentActivityVolunteer &&
            !activityResponse?.hasPermission && (
              <Grid item container justifyContent={'center'} alignItems={'center'} className="mb-2">
                <Button
                  variant="text"
                  sx={{
                    fontSize: '14px',
                    borderRadius: '20px',
                    height: '28px',
                    lineHeight: '12px',
                    cursor: 'auto',
                    color: isDarkMode ? '#FFCE00' : '#674BFF',
                    '&:hover': {
                      color: 'primary.light',
                    },
                  }}
                >
                  Thanks for joining.
                </Button>
              </Grid>
            )}
          {activityResponse?.activityStatus === 'RUNNING' && activityResponse?.category?.id !== 19 && (
            <Grid item container justifyContent={'center'} alignItems={'center'} className="mb-2">
              <Button
                variant="text"
                sx={{
                  fontSize: '14px',
                  borderRadius: '20px',
                  height: '28px',
                  lineHeight: '12px',
                  cursor: 'auto',
                  color: 'primary.light',
                  '&:hover': {
                    color: 'primary.light',
                  },
                }}
              >
                Started
              </Button>
            </Grid>
          )}

          {activityResponse?.participantOption !== "BOTH" && activityResponse?.activityStatus === 'RUNNING' &&
            !activityResponse?.currentActivityVolunteer &&
            !activityResponse?.hasPermission &&
            activityResponse?.category?.id === 19 && (
              <Grid item container justifyContent={'center'} alignItems={'center'} className="mb-2">
                <Tooltip
                  title={
                    activityResponse?.attendeeFilled
                      ? 'Attendee capacity is full'
                      : activityResponse?.volunteerFilled
                        ? 'Volunteer capacity is full'
                        : ''
                  }

                  arrow
                >
                  <span>
                    <Button
                      variant="contained"
                      style={{ textTransform: 'none' }}
                      sx={{
                        borderRadius: '15px', fontSize: '14px', fontWeight: '600',
                        cursor: activityResponse?.attendeeFilled || activityResponse?.volunteerFilled ? 'not-allowed' : 'pointer',
                      }}
                      onClick={() => {
                        if (activityResponse?.participantOption === "VOLUNTEER_ONLY") {
                          setSelectedParticipantOption("VOLUNTEER");
                        } else if (activityResponse?.participantOption === "ATTENDEE_ONLY") {
                          setSelectedParticipantOption("ATTENDEE");
                        }
                        handleVolunteerAs(activityResponse?.id);
                      }}
                      disabled={activityResponse?.attendeeFilled || activityResponse?.volunteerFilled}
                    >
                      {buttonText}
                    </Button>
                  </span>
                </Tooltip>
              </Grid>
            )}
          {activityResponse?.participantOption === "BOTH" && activityResponse?.activityStatus === 'RUNNING' &&
            !activityResponse?.currentActivityVolunteer &&
            !activityResponse?.hasPermission &&
            activityResponse?.category?.id === 19 && (
              <Grid item container justifyContent={'center'} alignItems={'center'} className="mb-2">
                <Button
                  variant="contained"
                  style={{ textTransform: 'none' }}
                  sx={{ borderRadius: '15px', fontSize: '14px', fontWeight: '600' }}
                  onClick={handleParticipantPopoverOpen}
                >
                  I want to join
                </Button>
              </Grid>
            )}
          {activityResponse?.activityStatus === 'RUNNING' && !activityResponse?.attendee &&
            activityResponse?.currentActivityVolunteer &&
            !activityResponse?.hasPermission &&
            activityResponse?.category?.id === 19 && (
              <Grid item container justifyContent={'center'} alignItems={'center'} className="mb-2">
                <Button
                  variant="text"
                  sx={{
                    fontSize: '14px',
                    borderRadius: '20px',
                    height: '28px',
                    lineHeight: '12px',
                    cursor: 'auto',
                    color: isDarkMode ? '#FFCE00' : '#674BFF',
                    '&:hover': {
                      color: isDarkMode ? '#FFCE00' : '#674BFF',
                    },
                  }}
                >
                  Thanks for joining.
                </Button>
              </Grid>
            )}

          {activityResponse?.activityStatus === 'RUNNING' && activityResponse?.attendee &&
            activityResponse?.currentActivityVolunteer &&
            !activityResponse?.hasPermission &&
            activityResponse?.category?.id === 19 && (
              <Grid item container justifyContent={'center'} alignItems={'center'} className="mb-2">
                <Button
                  variant="text"
                  sx={{
                    fontSize: '14px',
                    borderRadius: '20px',
                    height: '28px',
                    lineHeight: '12px',
                    cursor: 'auto',
                    color: isDarkMode ? '#FFCE00' : '#674BFF',
                    '&:hover': {
                      color: isDarkMode ? '#FFCE00' : '#674BFF',
                    },
                  }}
                >
                  Thanks for joining.
                </Button>
              </Grid>
            )}
          {activityResponse?.activityStatus === 'RUNNING' &&
            activityResponse?.category?.id === 19 &&
            !lostDone &&
            activityResponse?.hasPermission && (
              <Grid item container justifyContent={'center'} alignItems={'center'} className="mb-2">
                <Button
                  variant="contained"
                  sx={{
                    fontSize: '14px',
                    borderRadius: '20px',
                    height: '28px',
                    lineHeight: '12px',
                    '&:hover': {
                      backgroundColor: 'primary.main',
                      color: 'common.black',
                    },
                    width: 'fit-content',
                  }}
                  onClick={() => {
                    setConfirmLostPet(true);
                  }}
                >
                  Mark as done
                </Button>
              </Grid>
            )}

          {activityResponse?.activityStatus === 'RUNNING' &&
            activityResponse?.category?.id === 19 &&
            lostDone &&
            activityResponse?.hasPermission && (
              <Grid item container justifyContent={'center'} alignItems={'center'} className="mb-2">
                <Button
                  variant="text"
                  sx={{
                    fontSize: '14px',
                    borderRadius: '20px',
                    height: '28px',
                    lineHeight: '12px',
                    cursor: 'auto',
                    color: isDarkMode ? '#FFCE00' : '#674BFF',
                    '&:hover': {
                      color: isDarkMode ? '#FFCE00' : '#674BFF',
                    },
                  }}
                >
                  Activity completed
                </Button>
              </Grid>
            )}
          {activityResponse?.activityStatus === 'ENDED' && (
            <Grid item container justifyContent={'center'} alignItems={'center'} className="mb-2">
              <Button
                variant="text"
                sx={{
                  fontSize: '14px',
                  borderRadius: '20px',
                  height: '28px',
                  lineHeight: '12px',
                  cursor: 'auto',
                  color: isDarkMode ? '#FFCE00' : '#674BFF',
                  '&:hover': {
                    color: isDarkMode ? '#FFCE00' : '#674BFF',
                  },
                }}
              >
                Pending feedback
              </Button>
            </Grid>
          )}
          {activityResponse?.activityStatus === 'COMPLETED' && (
            <Grid item container justifyContent={'center'} alignItems={'center'} className="mb-2">
              <Button
                variant="text"
                style={{
                  cursor: 'default',
                }}
                sx={{
                  fontSize: '14px',
                  borderRadius: '20px',
                  height: '28px',
                  lineHeight: '12px',
                  color: 'primary.light',
                  '&:hover': {
                    color: 'primary.light',
                  },
                }}
              >
                Activity completed
              </Button>
            </Grid>
          )}

          {selectedOrgId && isVolunteerModalOpen && VolunteerModal}
          <Popover
            open={isParticipantPopoverOpen}
            anchorEl={participantAnchorEl}
            onClose={handleParticipantPopoverClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
          >
            <Box sx={{ padding: 2, width: '200px' }}>
              <Typography variant="h6">Join as</Typography>
              <Stack direction="column" spacing={2} mt={2}>
                <Tooltip
                  title={activityResponse?.attendeeFilled ? 'Attendee capacity is full' : ''}
                  arrow
                  disableHoverListener={!activityResponse?.attendeeFilled}
                >
                  <span>
                    <FormControlLabel
                      control={
                        <Radio
                          sx={{
                            color: isDarkMode ? '#FFCE00' : '#674BFF',
                            '&.Mui-checked': {
                              color: isDarkMode ? '#FFCE00' : '#674BFF',
                            },
                          }}
                          checked={selectedParticipantOption === 'ATTENDEE'}
                          onChange={() => setSelectedParticipantOption('ATTENDEE')}
                          disabled={activityResponse?.attendeeFilled}
                        />
                      }
                      label="Attendee"
                    />
                  </span>
                </Tooltip>
                <Tooltip
                  title={activityResponse?.volunteerFilled ? 'Volunteer capacity is full' : ''}
                  arrow
                  disableHoverListener={!activityResponse?.volunteerFilled}
                >
                  <span>
                    <FormControlLabel
                      control={
                        <Radio
                          sx={{
                            color: isDarkMode ? '#FFCE00' : '#674BFF',
                            '&.Mui-checked': {
                              color: isDarkMode ? '#FFCE00' : '#674BFF',
                            },
                          }}
                          checked={selectedParticipantOption === 'VOLUNTEER'}
                          onChange={() => setSelectedParticipantOption('VOLUNTEER')}
                          disabled={activityResponse?.volunteerFilled}
                        />
                      }
                      label="Volunteer"
                    />
                  </span>
                </Tooltip>
              </Stack>
              <Stack direction="row" spacing={2} justifyContent="flex-end" mt={2}>
                <Button
                  sx={{
                    color: isDarkMode ? '#FFCE00' : '#674BFF',
                  }}
                  onClick={handleParticipantPopoverClose}>Cancel</Button>
                <Button
                  sx={{
                    backgroundColor: isDarkMode ? '#FFCE00' : '#674BFF',
                    color: isDarkMode ? 'black' : '#ffff',
                    '&:hover': {
                      backgroundColor: isDarkMode ? '#FFCE00' : '#674BFF',
                    },
                  }}
                  onClick={() => {
                    handleParticipantPopoverClose();
                    handleVolunteerAs(activityResponse.id);
                  }}
                  disabled={!selectedParticipantOption}
                  variant="contained"
                >
                  Proceed
                </Button>

              </Stack>
            </Box>
          </Popover>

          <ActivityContribute
            open={isContributeOpen}
            handleClose={handleResourceClose}
            handleData={activityResponse}
            onPostClick={() => onIsSubmitClicked(true)}
          />

          <AllContributionsListModal open={viewContributions} handleClose={handleContributionsViewModalClose} activity={activityResponse} />

          {/* login modal */}
          <AuthorisationModal
            currentComponent={currentComponent}
            fullScreen={fullScreen}
            authModalOpen={authModalOpen}
            onClose={handleAuthModalClose}
            handleAuthModalClose={handleAuthModalClose}
            setCurrentComponent={setCurrentComponent}
          />
          <JoiningSuccessModal
            handleClose={handleModalClose}
            fullScreen={fullScreen}
            open={openModal}
            url={'chat url'}
            title={
              selectedParticipantOption === 'VOLUNTEER'
                ? 'Thanks for joining.'
                : 'Thanks for joining.'
            }
          />
        </Grid>
      )}

      <GenericModal
        handleClose={() => setConfirmLostPet(false)}
        fullScreen={fullScreen}
        open={confirmLostPet}
        title="Are you sure you want to mark this activity as done?"
        buttons={modalActionLostButtons}
      />
      <PhoneVerification
        handleClose={handlePhoneVerificationClose}
        open={phoneVerificationModal}
        fullScreen={isSmallerScreen}
        phoneInputCompleted={phoneInputCompleted}
        setPhoneInputCompleted={setPhoneInputCompleted}
        otpVerificationCompleted={otpVerificationCompleted}
        setotpVerificationCompleted={setOtpVerificationCompleted}
      />
      <RecurringRangeModal open={calDialogOpen} onClose={handleCloseModal} handleData={childrens} />
    </div>
  );
};
export default ActivityChatSideBar;
